///home/clement/compta-app/client/src/components/Reports/Comptables/GrandLivre.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  MenuItem
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const GrandLivre = () => {
  const [grandLivre, setGrandLivre] = useState([]);
  const [comptes, setComptes] = useState([]);
  const [selectedCompte, setSelectedCompte] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Récupération des comptes et du grand livre depuis l'API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [comptesResponse, grandLivreResponse] = await Promise.all([
          axios.get('/api/comptes'),
          axios.get('/api/grand-livre')
        ]);
        setComptes(comptesResponse.data);
        setGrandLivre(grandLivreResponse.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Filtrer les écritures par compte sélectionné
  const filteredEcritures = selectedCompte
    ? grandLivre.filter(ecriture => ecriture.compte === selectedCompte)
    : grandLivre;

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Erreur : {error}</Alert>;

  // Regrouper les écritures par compte
  const ecrituresParCompte = filteredEcritures.reduce((acc, ecriture) => {
    if (!acc[ecriture.compte]) {
      acc[ecriture.compte] = [];
    }
    acc[ecriture.compte].push(ecriture);
    return acc;
  }, {});

  return (
    <div className="grand-livre">
      <Typography variant="h4" gutterBottom>
        Grand Livre
      </Typography>

      {/* Filtre par compte */}
      <TextField
        select
        label="Filtrer par compte"
        value={selectedCompte}
        onChange={(e) => setSelectedCompte(e.target.value)}
        fullWidth
        margin="normal"
        variant="outlined"
      >
        <MenuItem value="">Tous les comptes</MenuItem>
        {comptes.map((compte) => (
          <MenuItem key={compte.numero} value={compte.numero}>
            {compte.numero} - {compte.libelle}
          </MenuItem>
        ))}
      </TextField>

      {/* Affichage des écritures par compte */}
      {Object.entries(ecrituresParCompte).map(([compte, ecritures]) => (
        <Accordion key={compte} defaultExpanded={!selectedCompte}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">
              <strong>Compte {compte}</strong>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Libellé</TableCell>
                    <TableCell>Débit</TableCell>
                    <TableCell>Crédit</TableCell>
                    <TableCell>Solde</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ecritures.map((ecriture, index) => (
                    <TableRow key={index}>
                      <TableCell>{ecriture.date}</TableCell>
                      <TableCell>{ecriture.libelle}</TableCell>
                      <TableCell>{ecriture.debit.toFixed(2)} €</TableCell>
                      <TableCell>{ecriture.credit.toFixed(2)} €</TableCell>
                      <TableCell>
                        {ecriture.solde.toFixed(2)} €
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default GrandLivre;
